// extracted by mini-css-extract-plugin
export default {"container":"fr-z","heading":"gr-z","text":"hr-z","info":"ir-z","link":"jr-z","fullMaxWidth":"kr-z"};